import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ca1d6d3e")

_pushScopeId("data-v-ca1d6d3e")
const _hoisted_1 = {
  key: 0,
  class: "modal-card"
}
const _hoisted_2 = { class: "modal-card-head modal-style" }
const _hoisted_3 = {
  key: 0,
  class: "modal-card-title has-text-white text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "modal-card-title has-text-white text-center"
}
const _hoisted_5 = { class: "modal-card-body modal-style" }
const _hoisted_6 = { key: "signup" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "control has-icons-left has-icons-right" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-user-secret" })
], -1)
const _hoisted_10 = {
  key: 0,
  class: "icon is-small is-right"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "help is-success"
}
const _hoisted_13 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { class: "control has-icons-left has-icons-right" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope" })
], -1)
const _hoisted_17 = {
  key: 0,
  class: "icon is-small is-right"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "help is-success"
}
const _hoisted_20 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_21 = { class: "field" }
const _hoisted_22 = { class: "control has-icons-left" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock" })
], -1)
const _hoisted_24 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_25 = { class: "field" }
const _hoisted_26 = { class: "control has-icons-left" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock" })
], -1)
const _hoisted_28 = {
  key: 0,
  class: "help is-danger",
  "data-testid": "register-error"
}
const _hoisted_29 = { class: "field" }
const _hoisted_30 = { class: "control has-icons-left" }
const _hoisted_31 = /*#__PURE__*/_createVNode("option", {
  selected: "",
  disabled: "",
  hidden: ""
}, "What's your level ?", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "icon is-medium is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-medal" })
], -1)
const _hoisted_33 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_34 = { class: "field" }
const _hoisted_35 = { class: "has-text-white" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" By signing up, you agree to ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" terms and conditions ")
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = {
  class: "text-center",
  key: "confirmEmail",
  "data-testid": "register-validation-email"
}
const _hoisted_40 = { class: "title is-4" }
const _hoisted_41 = /*#__PURE__*/_createVNode("p", null, " 🎉 you’re almost ready to start enjoying Cohackers! ", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("p", { class: "margin-t-24" }, [
  /*#__PURE__*/_createTextVNode(" To complete your inscription "),
  /*#__PURE__*/_createVNode("strong", { class: "has-text-white" }, "please confirm your email.")
], -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("strong", null, "OK, I UNDERSTAND", -1)
const _hoisted_44 = {
  key: 1,
  class: "modal-card"
}
const _hoisted_45 = { class: "modal-card-head modal-style" }
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "modal-card-title has-text-white text-center" }, " CHALLENGE ", -1)
const _hoisted_47 = { class: "modal-card-body modal-style" }
const _hoisted_48 = /*#__PURE__*/_createVNode("strong", { class: "has-text-white" }, "We have a challenge for you:", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("p", null, " There is a hidden input in this page that contains a value. Find the value in it to be able to register ", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("input", {
  type: "hidden",
  value: "8296216926242792255914442993"
}, null, -1)
const _hoisted_53 = { class: "field margin-t-24" }
const _hoisted_54 = { class: "control" }
const _hoisted_55 = { style: {"color":"red"} }
const _hoisted_56 = { class: "text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    class: `modal ${_ctx.active ? 'is-active' : ''}`
  }, [
    _createVNode("div", {
      class: "modal-background",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
    }),
    (_ctx.isDeveloper)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("header", _hoisted_2, [
            (!_ctx.validationEmail)
              ? (_openBlock(), _createBlock("p", _hoisted_3, " Sign up "))
              : (_openBlock(), _createBlock("p", _hoisted_4, " CONFIRM YOUR EMAIL ")),
            _createVNode("button", {
              class: "delete border-solid",
              "aria-label": "close",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            })
          ]),
          _createVNode("section", _hoisted_5, [
            (!_ctx.validationEmail)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.username = $event)),
                        class: 
                  `input is-background-black has-text-white ${
                    _ctx.usernameIsValid
                      ? 'is-success'
                      : _ctx.usernameIsInvalid
                      ? 'is-danger'
                      : ''
                  }`
                ,
                        type: "text",
                        placeholder: "Username",
                        "data-testid": "register-username-input"
                      }, null, 2), [
                        [_vModelText, _ctx.username]
                      ]),
                      _hoisted_9,
                      (_ctx.usernameIsValid)
                        ? (_openBlock(), _createBlock("span", _hoisted_10, [
                            _hoisted_11
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.usernameIsValid)
                      ? (_openBlock(), _createBlock("p", _hoisted_12, " This username is available "))
                      : _createCommentVNode("", true),
                    (_ctx.usernameIsInvalid)
                      ? (_openBlock(), _createBlock("p", _hoisted_13, " This username is invalid / unavailable "))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.email = $event)),
                        class: 
                  `input is-background-black has-text-white ${
                    _ctx.emailIsValid
                      ? 'is-success'
                      : _ctx.emailIsInvalid
                      ? 'is-danger'
                      : ''
                  }`
                ,
                        type: "email",
                        placeholder: "Email",
                        "data-testid": "register-email-input"
                      }, null, 2), [
                        [_vModelText, _ctx.email]
                      ]),
                      _hoisted_16,
                      (_ctx.emailIsValid)
                        ? (_openBlock(), _createBlock("span", _hoisted_17, [
                            _hoisted_18
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.emailIsValid)
                      ? (_openBlock(), _createBlock("p", _hoisted_19, " This email is available "))
                      : _createCommentVNode("", true),
                    (_ctx.emailIsInvalid)
                      ? (_openBlock(), _createBlock("p", _hoisted_20, " This email is invalid / unavailable "))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.password = $event)),
                        class: 
                  `input is-background-black has-text-white ${
                    _ctx.passwordIsInvalid ? 'is-danger' : ''
                  }`
                ,
                        type: "password",
                        placeholder: "Password",
                        "data-testid": "register-password-input"
                      }, null, 2), [
                        [_vModelText, _ctx.password]
                      ]),
                      _hoisted_23
                    ]),
                    (_ctx.passwordIsInvalid)
                      ? (_openBlock(), _createBlock("p", _hoisted_24, " The password should be at least 8 characters "))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmPassword = $event)),
                        class: 
                  `input is-background-black has-text-white ${
                    _ctx.confirmPasswordIsInvalid ? 'is-danger' : ''
                  }`
                ,
                        type: "password",
                        placeholder: "Confirm password",
                        "data-testid": "register-confirmPassword-input"
                      }, null, 2), [
                        [_vModelText, _ctx.confirmPassword]
                      ]),
                      _hoisted_27
                    ]),
                    (_ctx.confirmPasswordIsInvalid)
                      ? (_openBlock(), _createBlock("p", _hoisted_28, " Your passwords doesn't match "))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", _hoisted_30, [
                      _createVNode("div", {
                        class: `select is-white ${_ctx.levelIsInvalid ? 'is-danger' : ''}`
                      }, [
                        _withDirectives(_createVNode("select", {
                          class: "select-style",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.level = $event)),
                          "data-testid": "register-level-select"
                        }, [
                          _hoisted_31,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.arrayOfLevel, (level) => {
                            return (_openBlock(), _createBlock("option", {
                              key: level,
                              value: level
                            }, _toDisplayString(level), 9, ["value"]))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.level]
                        ])
                      ], 2),
                      _hoisted_32,
                      (_ctx.levelIsInvalid)
                        ? (_openBlock(), _createBlock("p", _hoisted_33, " This field is required "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_34, [
                    _createVNode("div", null, [
                      _createVNode("label", _hoisted_35, [
                        _hoisted_36,
                        _createVNode(_component_router_link, {
                          class: "has-text-white text-underline",
                          target: "_blank",
                          to: "/gtc"
                        }, {
                          default: _withId(() => [
                            _hoisted_37
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_38, [
                    _createVNode("button", {
                      class: "button is-background-green no-border margin-t-24",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.signup && _ctx.signup(...args))),
                      "data-testid": "register-submit-button"
                    }, " Sign up ")
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_39, [
                  _createVNode("h4", _hoisted_40, "Hey " + _toDisplayString(_ctx.username), 1),
                  _hoisted_41,
                  _hoisted_42,
                  _createVNode("a", {
                    class: "button margin-t-24 green-button",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, [
                    _hoisted_43
                  ])
                ]))
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_44, [
          _createVNode("header", _hoisted_45, [
            _hoisted_46,
            _createVNode("button", {
              class: "delete border-solid",
              "aria-label": "close",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            })
          ]),
          _createVNode("section", _hoisted_47, [
            _hoisted_48,
            _hoisted_49,
            _hoisted_50,
            _hoisted_51,
            _hoisted_52,
            _createVNode("div", _hoisted_53, [
              _createVNode("div", _hoisted_54, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.hiddenValue = $event)),
                  class: "input",
                  type: "text",
                  placeholder: "Value",
                  "data-testid": "is-developer-input"
                }, null, 512), [
                  [_vModelText, _ctx.hiddenValue]
                ])
              ])
            ]),
            _createVNode("p", _hoisted_55, _toDisplayString(_ctx.hiddenValueError), 1),
            _createVNode("div", _hoisted_56, [
              _createVNode("button", {
                class: "button is-background-green no-border margin-t-24 has-text-white",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args))),
                "data-testid": "is-developer-button"
              }, " Submit ")
            ])
          ])
        ]))
  ], 2))
})